import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

interface Dish {
  category: string;
  name: string;
  description: string;
  image: string;
  note?: string;
  price?: string;
}

const dishes: Dish[] = [
  { category: 'desayunos', name: 'Huevos al gusto', description: 'Con jamón, a la mexicana, rancheros, divorciados, con chorizo, con mole, con salsa pasilla, al albañil. Acompañados de frijoles y totopos.', image: '/img/Menuelchel/Huevoscontocino.JPG' },
  { category: 'desayunos', name: 'Sopes tradicionales', description: 'Con pollo o chorizo, 2 piezas. Acompañados de frijoles y totopos.', image: '/img/Menuelchel/sopes.JPG' },
  { category: 'desayunos', name: 'Molletes', description: 'Con queso y pico de gallo, 2 piezas.', image: '/img/molletes.jpg' },
  { category: 'desayunos', name: 'Chilaquiles verdes o rojos', description: 'Acompañados con pollo, cecina, arrachera o huevo.', image: '/img/Menuelchel/chilaquileszoncecina.JPG' },
  { category: 'desayunos', name: 'Enchiladas suizas', description: 'Verdes o rojas con pollo, 3 piezas.', image: '/img/Menuelchel/ENCHILADAS SUIZAS.JPG' },
  { category: 'desayunos', name: 'Enfrijoladas o Enmoladas', description: 'Con pollo, 3 piezas.', image: '/img/Menuelchel/ENCHILADAS ROJAS1.JPG' },
  { category: 'desayunos', name: 'Panuchos o Tacos de cochinita', description: '2 piezas por orden.', image: '/img/panuchos1.jpg' },
  { category: 'desayunos', name: 'Torta de cochinita', description: 'Preparada con frijoles refritos y cochinita pibil.', image: '/img/tortadecochinita.jpg' },
  { category: 'desayunos', name: 'Hot cakes', description: '3 piezas solas o acompañadas con jamón, tocino o huevo.', image: '/img/hotcakes.jpg' },
  { category: 'desayunos', name: 'Queso panela con nopal', description: '2 piezas.', image: '/img/quesopanelaconnopal.jpg' },
  { category: 'desayunos', name: 'Claras de huevo', description: 'Con jamón o a la mexicana.', image: '/img/Menuelchel/Huevo estrellado.JPG' },
  { category: 'comida', name: 'Chilaquiles con Bistec', description: 'Chilaquiles verdes o rojos con bistec (100 gr), crema, queso rallado y cebolla.', image: '/img/chilaquiles.jpg' },
  { category: 'comida', name: 'Cochinita Pibil', description: 'Deliciosa cochinita pibil, acompañada de cebolla morada y tortillas recién hechas.', image: '/img/cochinita.jpg' },
  { category: 'comida', name: 'Tacos dorados de cochinita', description: 'Tres tacos dorados rellenos de cochinita pibil, acompañados de encurtidos.', image: '/img/Menuelchel/flautas.JPG' },
  { category: 'comida', name: 'Chamorro al pibil', description: 'Delicioso chamorro al estilo pibil, servido con tortillas y cebolla morada.', image: '/img/chamorro.jpg' },
  { category: 'comida', name: 'Torta de cochinita', description: 'Torta rellena de cochinita pibil con cebolla morada.', image: '/img/tortadecochinita.jpg' },
  { category: 'comida', name: 'Paella (especial de la casa)', description: 'Prueba la deliciosa paella disponible los viernes, sábados y domingos, con opciones para mesa o para llevar.', image: '/img/Menuelchel/paella.JPG' },
  { category: 'comida', name: 'Sopa de lima', description: 'Sopa tradicional de lima con un toque de sabor auténtico.', image: '/img/sopalima.jpg' },
  { category: 'comida', name: 'Camarón extra', description: 'Adición de camarón para la paella.', note: 'Especialidad de la casa', image: '/img/camaron.jpg' },
  { category: 'comida', name: 'Ensalada El Chel', description: 'Una fresca combinación de lechuga, tomate, zanahoria rallada, pepino y aderezo especial.', image: '/img/Menuelchel/ensalada.JPG' },
  { category: 'comida', name: 'Nugets', description: 'Deliciosos trozos de pollo empanizado, crujientes por fuera y jugosos por dentro.', image: '/img/Menuelchel/nuggets.JPG' },
  { category: 'comida', name: 'Salchipapa', description: 'Papas fritas servidas con salchichas crujientes, acompañadas de salsas al gusto.', image: '/img/Menuelchel/salchipapa.JPG' },
  { category: 'comida', name: 'Pechuga al Chimichurri', description: 'Pechuga de pollo asada con un toque de chimichurri casero, ideal para los amantes de los sabores intensos.', image: '/img/Menuelchel/PECHUGA AL CHIMICHURRI.JPG' },
  { category: 'postres', name: 'Pan De Dulce', description: 'Delicioso pastel bañado en tres leches, servido con fresas.', image: '/img/Menuelchel/pan de dulce.JPG' },
  { category: 'postres', name: 'Pasteles del dia', description: 'Pregunte por las rebanadas disponibles de diferentes pastel', image: '/img/Menuelchel/pasteles.JPG' },
  { category: 'bebidas', name: 'Ron', description: 'Una selección de los rones más populares del mundo: Bacardí, Captain Morgan, Havana Club, Zacapa y Diplomático.', image: '/img/Menuelchel/ron.JPG' },
  { category: 'bebidas', name: 'Tequila', description: 'Disfruta de un buen tequila con estas marcas reconocidas: José Cuervo, Don Julio, Patrón, Herradura y 1800.', image: '/img/Menuelchel/tequila.JPG' },
  { category: 'bebidas', name: 'Whiskey', description: "Explora los sabores únicos de las mejores marcas de whiskey: Jack Daniel's, Jameson, Johnnie Walker, Chivas Regal y Macallan.", image: '/img/Menuelchel/whiskey.JPG' },
];

const categories = ['Todos', 'Desayunos', 'Comida', 'Postres', 'Bebidas'];

const MenuMesa: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const filteredDishes = selectedCategory
    ? dishes.filter((dish) => dish.category === selectedCategory)
    : dishes;

  return (
    <div className="bg-[#05603c]">
      {/* Category navbar */}
      <nav
        className="flex flex-wrap justify-center gap-2 px-1.5 py-3 border-b-2 border-brand-dark sticky top-0 z-50 bg-gradient-brand"
      >
        {categories.map((category) => {
          const key = category.toLowerCase();
          const isActive = selectedCategory === key || (key === 'todos' && !selectedCategory);
          return (
            <button
              key={category}
              onClick={() => setSelectedCategory(key === 'todos' ? null : key)}
              className={`px-3 py-2 text-[clamp(12px,1.5vw,16px)] border-2 rounded-[5px] cursor-pointer font-bold transition-colors duration-300 ${
                isActive
                  ? 'bg-white text-brand-dark border-white'
                  : 'bg-transparent text-white border-white hover:bg-white hover:text-brand-dark'
              }`}
            >
              {category}
            </button>
          );
        })}
      </nav>

      {/* Menu grid */}
      <section className="max-w-[1200px] mx-auto px-5 py-5">
        <Helmet>
          <title>Menú de Mesa | El Chel</title>
          <meta name="description" content="Conoce el menú de mesa de El Chel: desayunos, comida, postres y bebidas. Cochinita pibil y más en Tlalpan, CDMX." />
        </Helmet>
        <h1 className="text-[clamp(18px,2.5vw,30px)] text-white text-center mb-5 font-bold">Menú de Mesa</h1>

        {filteredDishes.length === 0 ? (
          <div className="text-center py-16">
            <p className="text-2xl font-bold text-white mb-2">Sin resultados</p>
            <p className="text-brand-deep">No hay platillos en esta categoría por el momento.</p>
          </div>
        ) : (
          <div className="grid gap-5" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))' }}>
            {filteredDishes.map((dish, index) => (
              <div
                key={index}
                className="flex flex-col items-center p-4 border-2 border-brand-deep rounded-[12px] bg-[#05603c] transition-transform duration-200 hover:scale-[1.02] shadow-brand-card"
              >
                <div className="relative w-full h-[200px] rounded-[8px] mb-2.5 overflow-hidden skeleton">
                <img
                  src={dish.image}
                  alt={dish.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-300"
                  onLoad={(e) => {
                    e.currentTarget.classList.replace('opacity-0', 'opacity-100');
                    e.currentTarget.parentElement?.classList.remove('skeleton');
                  }}
                />
              </div>
                <h2 className="text-[clamp(16px,1.5vw,20px)] text-white font-bold text-center my-2.5">{dish.name}</h2>
                <p className="text-[clamp(14px,1.2vw,16px)] text-[#e65100] text-center mb-2.5">{dish.description}</p>
                {dish.note && <p className="text-[clamp(14px,1.2vw,18px)] font-bold text-brand-deep text-center">{dish.note}</p>}
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default MenuMesa;
